import { VISUAL_PAGE_FLOW } from "../../data/reportContent";

export const PageFlowOverview = () => (
  <div className="page-flow" data-testid="page-flow-overview">
    {VISUAL_PAGE_FLOW.map((v, i) => (
      <div className="page-flow-node" key={v.label}>
        <div className="page-flow-label">{v.label}</div>
        <div className="page-flow-role">{v.role}</div>
        <div className="page-flow-question">{v.question}</div>
        {i < VISUAL_PAGE_FLOW.length - 1 && <span className="page-flow-arrow" aria-hidden="true">→</span>}
      </div>
    ))}
  </div>
);
